import {
    getAttentionText,
    getErrorText,
    getWarningText,
    getExternalLinkText,
    getErrorLoginUserText,
} from './data'

// Reducer is exposed so that we can hook up the state
export { default as commonTextsReducer } from './data/reducer'

// Middleware is exposed so that we can hook it up to the store creation
export { default as middleware } from './middleware'

// Selectors are exposed as a way for the surrounding to query the
// state from the feature
export const selectors = {
    getAttentionText, // Backend
    getErrorText, // Backend
    getWarningText,
    getExternalLinkText, // Settings
    getErrorLoginUserText, // Backend
}



// WEBPACK FOOTER //
// ./src/features/CommonTexts/exports.js